// require('dotenv').config()

/* handy object & functions */
var rules = {
  required: (val) => val !== '' || 'Required',
  mobile: (val) => {
    const pattern = /^[0-9]+$/
    return pattern.test(val) || val === '' || 'Invalid mobile number'
  },
  email: (val) => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(val) || 'E-mail address must be valid'
  },
  minimum: (val) => val.length >= 5 || 'Min 5 characters'
}

var customToolbar = [
  ['bold', 'italic', 'underline'],
  [{'header': ['1', '2']}],
  [{'list': 'ordered'}]
]

// format the date to DB date
function formatDBDate (dt) {
  var d = new Date(dt)
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  return [year, month, day].join('-')
}

// format to desired date to display
function formatDate (dt) {
  var d = new Date(dt)
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('-')
}

// format to desired long date to display
function formatLongDate (dt) {
  var d = new Date(dt)
  var month = d.getMonth()
  var day = '' + d.getDate()
  var year = d.getFullYear()
  if (day.length < 2) day = '0' + day
  return [day, getMonthName(month), year].join(' ')
}

// get month name
function getMonthName (m) {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthNames[m]
}

// format to desired date to display
function formatDateTime (dt) {
  var str = ''
  var today = new Date()
  var d = new Date(dt)
  // check for short forms
  var diff = today - d
  var min = diff / 60000
  var hr = min / 60
  if (hr < 1) {
    str = Math.round(min) + ' min'
  } else if (hr < 12) {
    str = Math.round(hr) + ' hr'
  } else { // long time
    str = d.toDateString()
    // strip year if the current year
    if (today.getFullYear() === d.getFullYear()) {
      str = str.substring(0, str.indexOf(today.getFullYear()))
    }
    // with am/pm
    var hours = d.getHours()
    var minutes = d.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    str += ' ' + hours + ':' + minutes + ' ' + ampm
  }
  return str
}

// get time from date
function getTime12Hrs (dt) {
  var d = new Date(dt)
  var hours = d.getHours()
  var minutes = d.getMinutes()
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  return (hours + ':' + minutes + ' ' + ampm)
}

// get time from date
function getTime (dt) {
  var d = new Date(dt)
  d = ('00' + d.getHours()).slice(-2) + ':' +
  ('00' + d.getMinutes()).slice(-2)
  return d
}

// get hh:mm from date
function getLongTime (dt) {
  var d = new Date(dt)
  d = ('00' + d.getHours()).slice(-2) + ':' +
  ('00' + d.getMinutes()).slice(-2)
  return d
}

// format to desired time to display
function formatTime (t) {
  var str = ''
  var hours = t.substring(0, 2)
  var minutes = t.substring(3, 5)
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
  str = hours + ':' + minutes + '' + ampm
  return str
}

// format to desired time to store in DB
function formatDBTime (t) {
  var str = ''
  var hours = t.substring(0, 2)
  var minutes = t.substring(3, 5)
  str = hours + ':' + minutes
  return str
}

function dateDiffInDays (a, b) {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24
  // Discard the time and time-zone information.
  return Math.ceil((b - a) / _MS_PER_DAY) + 1
}

function dateDiffInMins (a, b) {
  var _MS_PER_MIN = 1000 * 60
  return Math.round((b - a) / _MS_PER_MIN)
}

function getDatesBetween (startDate, stopDate) {
  var dateArray = []
  var currentDate = startDate
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate))
    currentDate = addDays(currentDate, 1)
  }
  return dateArray
}

function addDays (dt, days) {
  var date = new Date(dt)
  date.setDate(date.getDate() + days)
  return date
}

// first letter capital
function startWithUpper (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// function & style to display html content comes out of vue2-editor (to fix spacing issues)
function getEditorStyle () {
  return '<style>p {margin-top:0; margin-bottom:0} ol {margin-left:40px}</style>'
}

function fixHtmlSpacing (str) {
  return str.replace(/<p><br><\/p>/g, '<br>')
}

function unique (list) {
  return list.filter((x, i, a) => a.indexOf(x) === i)
}

function diff (a, b) {
  return a.filter((i) => b.indexOf(i) < 0)
}

// function to format currency based on the config
function formatCur (amt) {
  var pfix = ''
  var sfix = ''
  amt = amt || 0
  if (amt < 0) {
    amt = Math.abs(amt)
    pfix = '('
    sfix = ')'
  }
  return pfix + this.CURRENCY + amt.toLocaleString(('en-' + this.COMM_COUNTRY_CODE), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + sfix
}

function formatCurPDF (amt) {
  var pfix = (this.COMM_COUNTRY_CODE === 'IN' ? 'INR ' : this.CURRENCY)
  amt = amt || 0
  return pfix + amt.toLocaleString(('en-' + this.COMM_COUNTRY_CODE), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

function formatDBDateTime (dt) {
  var date = new Date(dt)
  date = date.getFullYear() + '-' +
  ('00' + (date.getMonth() + 1)).slice(-2) + '-' +
  ('00' + date.getDate()).slice(-2) + ' ' +
  ('00' + date.getHours()).slice(-2) + ':' +
  ('00' + date.getMinutes()).slice(-2) + ':' +
  ('00' + date.getSeconds()).slice(-2)
  return date
}

function formatDisplayDateTime (dt) {
  var date = new Date(dt)
  var str = ('00' + date.getDate()).slice(-2) + '-' +
  ('00' + (date.getMonth() + 1)).slice(-2) + '-' +
  date.getFullYear() + ' '
  var hours = ('00' + date.getHours()).slice(-2)
  var minutes = ('00' + date.getMinutes()).slice(-2)
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours !== 0 ? hours : 12 // the hour '0' should be '12'
  str = str + hours + ':' + minutes + '' + ampm

  return str
}

function html2text (str) {
  return str.replace(/<[^>]*>?/gm, ' ')
}

function getWeekOfTheYear (dt) {
  var date = new Date(dt)
  var oneJan = new Date(date.getFullYear(), 0, 1)
  // calculating number of days
  // in given year before given date
  var numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000))
  // adding 1 since date.getDay()
  // returns value starting from 0
  var getDay = (date.getDay() === 1 || date.getDay() === 2) ? 5 : date.getDay()
  return ((getDay + 1 + numberOfDays) / 7).toFixed(0)
}

function getDateOfWeek (w, y) {
  var date = new Date(y, 0, 1 + (w - 1) * 7)
  var day = date.getDay()
  var weekStart = date
  if (day <= 4) {
    weekStart.setDate(date.getDate() - day + 1)
  } else {
    weekStart.setDate(date.getDate() + 8 - day)
  }
  return formatDBDate(weekStart)
}

function getLastDayoftheMonth (y, m) {
  return new Date(y, m + 1, 0).getDate()
}

function getWeekNumber70 (d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
  // Return array of year and week number
  return weekNo
}

function getWeekNumberOfYear70 (d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
  // Get first day of year
  // var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  // Calculate full weeks to nearest Thursday
  // var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
  // Return array of year and week number
  return d.getUTCFullYear()
}
function loadImg (path, isShared = false) {
  try {
    return ('https://us-bb-space.blr1.digitaloceanspaces.com/' + path)
    // return ('https://uniservice-bb-storage.blr1.digitaloceanspaces.com/' + path)
    // return isShared ? ('assets/common/' + path) : ('./assets/' + path)
  } catch (e) {
    return 'assets/unknown.png'
  }
}

module.exports = {
  // global configs used with in handy js
  CURRENCY: '₹ ',
  COMM_COUNTRY_CODE: 'IN',
  // handy functions
  rules,
  customToolbar,
  formatDate,
  formatLongDate,
  formatDateTime,
  formatDBDate,
  getMonthName,
  getTime,
  getLongTime,
  formatTime,
  formatDBTime,
  dateDiffInDays,
  dateDiffInMins,
  getDatesBetween,
  startWithUpper,
  getEditorStyle,
  fixHtmlSpacing,
  unique,
  diff,
  formatCur,
  formatCurPDF,
  formatDBDateTime,
  formatDisplayDateTime,
  getTime12Hrs,
  html2text,
  getWeekOfTheYear,
  getWeekNumber70,
  getWeekNumberOfYear70,
  getDateOfWeek,
  getLastDayoftheMonth,
  loadImg
}



// WEBPACK FOOTER //
// ./src/utils/handy.js